import { toast } from "bulma-toast";
import { saveAs } from 'file-saver';
import * as JSZip from 'jszip';
import * as React from "react";
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { loadGenDetails, resetProfile } from "src/utils/api";
import "../../../node_modules/bulma-extensions/bulma-divider/dist/css/bulma-divider.min.css";
import "../../../node_modules/flag-icon-css/css/flag-icon.css";
import { appLanguage, deleteConfirmation, editorTheme, generatorView, loggingAllowed, preferredEditor, tooltips } from "../../constants/profileSettings";
import Profile from "../../models/Profile";
import GeneratorEntity from './../../models/Generator';
import { TopNav } from "./TopNav";
import translations from "./translations";




interface IProps extends InjectedIntlProps {
  profile: Profile;
  generators: GeneratorEntity[]

  switchAppLanguage: any;
  switchEditTheme: any;
  switchEditView: any;
  switchGenView: any;

  reloadProfile: () => void;
  switchLogging: (setting: loggingAllowed) => void;
  switchTooltipsSettings: (settings: tooltips) => void;
  toggleDelConf: (bool: deleteConfirmation) => void;
}

interface IState {
  showCredits: boolean;
  checkedRestore: boolean;
}
class ProfileComponent extends React.Component<IProps, IState> {
  private activeButton: string = "button is-info";
  private button: string = "button";

  private credits = [
    {
      credit: "Hugues Adamo http://unsplash.com/@hugueshh",
      name: "Cover Image"
    },
    {
      credit: `The MIT License (MIT)

      Copyright (c) 2018 Jeremy Thomas

      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in
      all copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      THE SOFTWARE.`,
      link: "http://bulma.io",
      name: "Bulma.io"
    },
    {
      credit: `Font Awesome Free License
      -------------------------

      Font Awesome Free is free, open source, and GPL friendly. You can use it for
      commercial projects, open source projects, or really almost whatever you want.
      Full Font Awesome Free license: https://fontawesome.com/license/free.

      # Icons: CC BY 4.0 License (https://creativecommons.org/licenses/by/4.0/)
      In the Font Awesome Free download, the CC BY 4.0 license applies to all icons
      packaged as SVG and JS file types.

      # Fonts: SIL OFL 1.1 License (https://scripts.sil.org/OFL)
      In the Font Awesome Free download, the SIL OLF license applies to all icons
      packaged as web and desktop font files.

      # Code: MIT License (https://opensource.org/licenses/MIT)
      In the Font Awesome Free download, the MIT license applies to all non-font and
      non-icon files.

      # Attribution
      Attribution is required by MIT, SIL OLF, and CC BY licenses. Downloaded Font
      Awesome Free files already contain embedded comments with sufficient
      attribution, so you shouldn't need to do anything additional when using these
      files normally.

      We've kept attribution comments terse, so we ask that you do not actively work
      to remove them from files, especially code. They're a great way for folks to
      learn about Font Awesome.

      # Brand Icons
      All brand icons are trademarks of their respective owners. The use of these
      trademarks does not indicate endorsement of the trademark holder by Font
      Awesome, nor vice versa. **Please do not use brand logos for any purpose except
      to represent the company, product, or service to which they refer.**`,
      link: "https://fontawesome.com/",
      name: "Fontawesome"
    },
    {
      credit: `The MIT License (MIT)

      Copyright (c) 2017 Glenn Flanagan

      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`,
      link: "https://github.com/glennflanagan/react-collapsible",
      name: "React-Collapsible"
    },
    {
      credit: `The MIT License (MIT)

      Copyright (c) 2016 Nik Butenko

      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all
      copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
      SOFTWARE.`,
      link: "https://github.com/nkbt/react-copy-to-clipboard",
      name: "react-copy-to-clipboard"
    },
    {
      credit: `Copyright 2014 Yahoo Inc. All rights reserved.`,
      link: "https://github.com/yahoo/react-intl",
      name: "react-intl"
    },
    {
      credit: `MIT License

      Copyright (c) 2017 Wikiki

      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all
      copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE`,
      link: "https://github.com/Wikiki/bulma-extensions",
      name: "Bulma extensions"
    },
    {
      credit: `MIT License

      Copyright (c) 2018 Rafael Franco

      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all
      copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
      SOFTWARE.`,
      link: "https://rfoel.github.io/bulma-toast/",
      name: "bulma-toast"
    },
    {
      credit: `The MIT License (MIT)

      Copyright (c) 2013 Panayiotis Lipiridis

      Permission is hereby granted, free of charge, to any person obtaining a copy of
      this software and associated documentation files (the "Software"), to deal in
      the Software without restriction, including without limitation the rights to
      use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
      of the Software, and to permit persons to whom the Software is furnished to do
      so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all
      copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
      SOFTWARE.`,
      link: "http://flag-icon-css.lip.is/",
      name: "flag-icon-css"
    },
    {
      credit: `Copyright (c) JS Foundation and other contributors

      Permission is hereby granted, free of charge, to any person
      obtaining a copy of this software and associated documentation
      files (the "Software"), to deal in the Software without
      restriction, including without limitation the rights to use,
      copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the
      Software is furnished to do so, subject to the following
      conditions:

      The above copyright notice and this permission notice shall be
      included in all copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
      EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
      OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
      NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
      HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
      WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
      FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
      OTHER DEALINGS IN THE SOFTWARE.`,
      link: "http://momentjs.com/",
      name: "moment.js"
    },
    {
      credit: `The MIT License (MIT)

      Copyright (c) 2018 Microsoft Corporation

      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`,
      link: "https://microsoft.github.io/monaco-editor/",
      name: "Monaco Editor"
    },
    {
      credit: `Copyright (c) 2013-2016 Andrew Nesbitt

      Permission is hereby granted, free of charge, to any person obtaining
      a copy of this software and associated documentation files (the
      "Software"), to deal in the Software without restriction, including
      without limitation the rights to use, copy, modify, merge, publish,
      distribute, sublicense, and/or sell copies of the Software, and to
      permit persons to whom the Software is furnished to do so, subject to
      the following conditions:

      The above copyright notice and this permission notice shall be
      included in all copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
      EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
      NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
      LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
      OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
      WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`,
      link: "https://npmjs.org/package/node-sass",
      name: "node-sass"
    },
    {
      credit: `Apache License

      Version 2.0, January 2004

      http://www.apache.org/licenses/

      TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

      1. Definitions.

      "License" shall mean the terms and conditions for use, reproduction, and distribution as defined by Sections 1 through 9 of this document.

      "Licensor" shall mean the copyright owner or entity authorized by the copyright owner that is granting the License.

      "Legal Entity" shall mean the union of the acting entity and all other entities that control, are controlled by, or are under common control with that entity. For the purposes of this definition, "control" means (i) the power, direct or indirect, to cause the direction or management of such entity, whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding shares, or (iii) beneficial ownership of such entity.

      "You" (or "Your") shall mean an individual or Legal Entity exercising permissions granted by this License.

      "Source" form shall mean the preferred form for making modifications, including but not limited to software source code, documentation source, and configuration files.

      "Object" form shall mean any form resulting from mechanical transformation or translation of a Source form, including but not limited to compiled object code, generated documentation, and conversions to other media types.

      "Work" shall mean the work of authorship, whether in Source or Object form, made available under the License, as indicated by a copyright notice that is included in or attached to the work (an example is provided in the Appendix below).

      "Derivative Works" shall mean any work, whether in Source or Object form, that is based on (or derived from) the Work and for which the editorial revisions, annotations, elaborations, or other modifications represent, as a whole, an original work of authorship. For the purposes of this License, Derivative Works shall not include works that remain separable from, or merely link (or bind by name) to the interfaces of, the Work and Derivative Works thereof.

      "Contribution" shall mean any work of authorship, including the original version of the Work and any modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized to submit on behalf of the copyright owner. For the purposes of this definition, "submitted" means any form of electronic, verbal, or written communication sent to the Licensor or its representatives, including but not limited to communication on electronic mailing lists, source code control systems, and issue tracking systems that are managed by, or on behalf of, the Licensor for the purpose of discussing and improving the Work, but excluding communication that is conspicuously marked or otherwise designated in writing by the copyright owner as "Not a Contribution."

      "Contributor" shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution has been received by Licensor and subsequently incorporated within the Work.

      2. Grant of Copyright License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display, publicly perform, sublicense, and distribute the Work and such Derivative Works in Source or Object form.

      3. Grant of Patent License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except as stated in this section) patent license to make, have made, use, offer to sell, sell, import, and otherwise transfer the Work, where such license applies only to those patent claims licensable by such Contributor that are necessarily infringed by their Contribution(s) alone or by combination of their Contribution(s) with the Work to which such Contribution(s) was submitted. If You institute patent litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the Work constitutes direct or contributory patent infringement, then any patent licenses granted to You under this License for that Work shall terminate as of the date such litigation is filed.
import { deleteConfirmation } from 'src/constants/profileSettings';


      4. Redistribution. You may reproduce and distribute copies of the Work or Derivative Works thereof in any medium, with or without modifications, and in Source or Object form, provided that You meet the following conditions:

      You must give any other recipients of the Work or Derivative Works a copy of this License; and
      You must cause any modified files to carry prominent notices stating that You changed the files; and
      You must retain, in the Source form of any Derivative Works that You distribute, all copyright, patent, trademark, and attribution notices from the Source form of the Work, excluding those notices that do not pertain to any part of the Derivative Works; and
      If the Work includes a "NOTICE" text file as part of its distribution, then any Derivative Works that You distribute must include a readable copy of the attribution notices contained within such NOTICE file, excluding those notices that do not pertain to any part of the Derivative Works, in at least one of the following places: within a NOTICE text file distributed as part of the Derivative Works; within the Source form or documentation, if provided along with the Derivative Works; or, within a display generated by the Derivative Works, if and wherever such third-party notices normally appear. The contents of the NOTICE file are for informational purposes only and do not modify the License. You may add Your own attribution notices within Derivative Works that You distribute, alongside or as an addendum to the NOTICE text from the Work, provided that such additional attribution notices cannot be construed as modifying the License.

      You may add Your own copyright statement to Your modifications and may provide additional or different license terms and conditions for use, reproduction, or distribution of Your modifications, or for any such Derivative Works as a whole, provided Your use, reproduction, and distribution of the Work otherwise complies with the conditions stated in this License.
      5. Submission of Contributions. Unless You explicitly state otherwise, any Contribution intentionally submitted for inclusion in the Work by You to the Licensor shall be under the terms and conditions of this License, without any additional terms or conditions. Notwithstanding the above, nothing herein shall supersede or modify the terms of any separate license agreement you may have executed with Licensor regarding such Contributions.

      6. Trademarks. This License does not grant permission to use the trade names, trademarks, service marks, or product names of the Licensor, except as required for reasonable and customary use in describing the origin of the Work and reproducing the content of the NOTICE file.

      7. Disclaimer of Warranty. Unless required by applicable law or agreed to in writing, Licensor provides the Work (and each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for determining the appropriateness of using or redistributing the Work and assume any risks associated with Your exercise of permissions under this License.

      8. Limitation of Liability. In no event and under no legal theory, whether in tort (including negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including any direct, indirect, special, incidental, or consequential damages of any character arising as a result of this License or out of the use or inability to use the Work (including but not limited to damages for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses), even if such Contributor has been advised of the possibility of such damages.

      9. Accepting Warranty or Additional Liability. While redistributing the Work or Derivative Works thereof, You may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or other liability obligations and/or rights consistent with this License. However, in accepting such obligations, You may act only on Your own behalf and on Your sole responsibility, not on behalf of any other Contributor, and only if You agree to indemnify, defend, and hold each Contributor harmless for any liability incurred by, or claims asserted against, such Contributor by reason of your accepting any such warranty or additional liability.`,
      link: "https://github.com/IdentityModel/oidc-client-js",
      name: "oidc-client"
    },
    {
      credit: `MIT License

      Copyright (c) Facebook, Inc. and its affiliates.

      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all
      copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
      SOFTWARE.`,
      link: "https://reactjs.org/",
      name: "https://reactjs.org/"
    },
    {
      credit: `The MIT License (MIT)

      Copyright (c) 2017 Maximilian Mantz

      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all
      copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
      SOFTWARE.`,
      link: "https://github.com/maxmantz/redux-oidc",
      name: "redux-oidc"
    },
    {
      credit: `Copyright (c) 2015-present James Long

      Permission is hereby granted, free of charge, to any person obtaining a copy of
      this software and associated documentation files (the "Software"), to deal in
      the Software without restriction, including without limitation the rights to
      use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
      of the Software, and to permit persons to whom the Software is furnished to do
      so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all
      copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
      SOFTWARE.`,
      link: "https://www.npmjs.com/package/react-router-redux",
      name: "redux-router"
    },
    {
      credit: `22 lines (17 sloc)  1.06 KB
      The MIT License (MIT)

      Copyright (c) 2015-present Dan Abramov

      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`,
      link: "https://github.com/reduxjs/redux",
      name: "redux"
    },
    {
      credit: `The MIT License

      Copyright (c) 2015 Ola Holmström <olaholmstrom+github@gmail.com>

      Permission is hereby granted, free of charge, to any person obtaining a copy of
      this software and associated documentation files (the "Software"), to deal in
      the Software without restriction, including without limitation the rights to
      use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
      of the Software, and to permit persons to whom the Software is furnished to do
      so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all
      copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
      SOFTWARE.`,
      link: "https://github.com/olahol/react-tagsinput",
      name: "react-tagsinput"
    },
    {
      credit: `The MIT License (MIT)

      Copyright (c) 2015 Nik Butenko

      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:

      The above copyright notice and this permission notice shall be included in all
      copies or substantial portions of the Software.

      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
      SOFTWARE.`,
      link: "https://github.com/nkbt/react-collapse",
      name: "react-collapse"
    }
  ];

  public constructor(props: IProps) {
    super(props);
    this.state = {
      checkedRestore: false,
      showCredits: false
    };
  }

  public toggleCredits = () => {
    this.setState({
      showCredits: !this.state.showCredits
    });
  };

  public renderedCredits = () => {
    const retVal: any = [];
    retVal.push(<br key={"emtptyLine123"} />);
    this.credits.map((item, index) => {
      retVal.push(
        <div key={item.name + index}>
          <div>
            <p className="subtitle">
              <a href={item.link}>{item.name}</a>
            </p>
            <p>{item.credit}</p>
          </div>
          <br />
          <br />
          <br />
        </div>
      );
    });
    return retVal;
  };

  public render() {
    return (
      <>
        <TopNav />
        <div className="box">
          <div className="tile is-ancestor">
            <div className="tile is-vertical is-12">
              <div className="tile">
                <div className="tile is-parent is-vertical is-4">
                  <article className="tile is-child notification is-info">
                    <h1 className="title">
                      <FormattedMessage {...translations.userinterface} />
                    </h1>
                    <p>
                      <FormattedMessage {...translations.userinterfaceDesc} />
                    </p>
                  </article>
                </div>
                <div className="tile is-parent">
                  <article className="tile is-child notification is-light">
                    <label className="label">
                      <FormattedMessage {...translations.generatorview} />
                    </label>
                    <div className="field has-addons">
                      <p className="control">
                        <button className={this.props.profile.generatorView === generatorView.cardView ? this.activeButton : this.button} onClick={this.buttonCardView}>
                          <span className="icon is-small">
                            <i className="fa fa-table" />
                          </span>
                          <span>
                            <FormattedMessage {...translations.cardview} />
                          </span>
                        </button>
                      </p>
                      <p className="control">
                        <a className={this.props.profile.generatorView === generatorView.listView ? this.activeButton : this.button} onClick={this.buttonListView}>
                          <span className="icon is-small">
                            <i className="fa fa-list" />
                          </span>
                          <span>
                            <FormattedMessage {...translations.listview} />
                          </span>
                        </a>
                      </p>

                    </div>
                    <div className="field">
                      {/* Language */}
                      <label className="label">
                        <FormattedMessage {...translations.language} />
                      </label>
                      <div className="field has-addons">
                        <p className="control">
                          <a className={this.props.profile.appLanguage === appLanguage.english ? this.activeButton : this.button} onClick={this.buttonLanguageEn}>
                            <span className="icon is-small">
                              <i className="flag-icon flag-icon-gb" />
                            </span>
                            <span> English</span>
                          </a>
                        </p>
                        <p className="control">
                          <a className={this.props.profile.appLanguage === appLanguage.german ? this.activeButton : this.button} onClick={this.buttonLanguageDe}>
                            <span className="icon is-small">
                              <i className="flag-icon flag-icon-de" />
                            </span>
                            <span> Deutsch</span>
                          </a>
                        </p>
                        <p className="control">
                          <a className={this.props.profile.appLanguage === appLanguage.finnish ? this.activeButton : this.button} onClick={this.buttonLanguageFi}>
                            <span className="icon is-small">
                              <i className="flag-icon flag-icon-fi" />
                            </span>
                            <span> Suomi</span>
                          </a>
                        </p>
                      </div>
                    </div>
                    {/* Tooltips */}
                    <label className="label">
                      <FormattedMessage {...translations.showTooltips} />
                    </label>
                    <div className="field has-addons">
                      <p className="control">
                        <button className={this.props.profile.showTooltips === tooltips.on ? this.activeButton : this.button} onClick={this.buttonToggleTooltip}>
                          <span className="icon is-small">
                            <i className="far fa-check" />
                          </span>
                          <span>
                            <FormattedMessage {...translations.yes} />
                          </span>
                        </button>
                      </p>
                      <p className="control">
                        <a className={this.props.profile.showTooltips === tooltips.off ? this.activeButton : this.button} onClick={this.buttonToggleTooltip}>
                          <span className="icon is-small">
                            <i className="far fa-times" />
                          </span>
                          <span>
                            <FormattedMessage {...translations.no} />
                          </span>
                        </a>
                      </p>
                    </div>
                    {/* Delete Confirmation */}
                    <label className="label">
                      {/* <FormattedMessage {...translations.showTooltips} /> */}
                      Ask before deletion? <br /> (Warning: This deletes Generators without asking for confirmation!!!)
                    </label>
                    <div className="field has-addons">
                      <p className="control">
                        <button className={this.props.profile.deleteConfirmation === deleteConfirmation.true ? this.activeButton : this.button} onClick={(b) => this.btnToggleDelete(deleteConfirmation.true)}>{/* tslint:disable-line */}
                          <span className="icon is-small">
                            <i className="far fa-check" />
                          </span>
                          <span>
                            <FormattedMessage {...translations.yes} />
                          </span>
                        </button>
                      </p>
                      <p className="control">
                        <a className={this.props.profile.deleteConfirmation === deleteConfirmation.false ? this.activeButton : this.button} onClick={(b) => this.btnToggleDelete(deleteConfirmation.false)}>{/* tslint:disable-line */}
                          <span className="icon is-small">
                            <i className="far fa-times" />
                          </span>
                          <span>
                            <FormattedMessage {...translations.no} />
                          </span>
                        </a>
                      </p>

                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
          {/* Editor Settings */}
          <div className="tile is-ancestor">
            <div className="tile is-vertical is-12">
              <div className="tile">
                <div className="tile is-parent is-vertical is-4">
                  <article className="tile is-child notification is-info">
                    <h1 className="title">
                      <FormattedMessage {...translations.editorsettings} />
                    </h1>
                    <p>
                      <FormattedMessage {...translations.editorsettingsdesc} />
                    </p>
                  </article>
                </div>
                <div className="tile is-parent">
                  <article className="tile is-child notification is-light">
                    <div className="field">
                      <label className="label">
                        <FormattedMessage {...translations.editorview} />
                      </label>
                      <div className="field has-addons">
                        <p className="control">
                          <a className={this.props.profile.preferredEditor === preferredEditor.formEditor ? this.activeButton : this.button} onClick={this.buttonFormsEditor}>
                            <span className="icon is-small">
                              <i className="far fa-mouse-pointer" />
                            </span>
                            <span>
                              <FormattedMessage {...translations.forms} />
                            </span>
                          </a>
                        </p>
                        <p className="control">
                          <a className={this.props.profile.preferredEditor === preferredEditor.codeEditor ? this.activeButton : this.button} onClick={this.buttonCodeEditor}>
                            <span className="icon is-small">
                              <i className="fal fa-keyboard" />
                            </span>
                            <span>
                              <FormattedMessage {...translations.code} />
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>

                    {/* Editor Theme */}
                    <div className="field">
                      <label className="label">
                        <FormattedMessage {...translations.theme} />
                      </label>
                      <div className="field has-addons">
                        <p className="control">
                          <a className={this.props.profile.editorTheme === editorTheme.vsDark ? this.activeButton : this.button} onClick={this.buttonThemeDark}>
                            <span className="icon is-small">
                              <i className="fal fa-moon" />
                            </span>
                            <span>
                              <FormattedMessage {...translations.dark} />
                            </span>
                          </a>
                        </p>
                        <p className="control">
                          <a className={this.props.profile.editorTheme === editorTheme.vsLight ? this.activeButton : this.button} onClick={this.buttonThemeLight}>
                            <span className="icon is-small">
                              <i className="fal fa-sun" />
                            </span>
                            <span>
                              <FormattedMessage {...translations.light} />
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>

          {/* Logging stuff Stuff */}

          {/* Editor Settings */}
          <div className="tile is-ancestor">
            <div className="tile is-vertical is-12">
              <div className="tile">
                <div className="tile is-parent is-vertical is-4">
                  <article className="tile is-child notification is-info">
                    <h1 className="title">
                      {/* <FormattedMessage {...translations.editorsettings} /> */}
                      Your Experience
                    </h1>
                    <p>
                      {/* <FormattedMessage {...translations.editorsettingsdesc} /> */}
                      To create a better experience we collect some anonymous data on usage.
                    </p>
                  </article>
                </div>
                <div className="tile is-parent">
                  <article className="tile is-child notification is-light">
                    <div className="field">
                      <label className="label">
                        {/* <FormattedMessage {...translations.editorview} /> */}
                        To create a better experience we need some data on how the page is used.
                        <br />
                        Do you allow us to collect some anonymous data?
                      </label>
                      <div className="field has-addons">
                        <p className="control">
                          <a className={this.props.profile.loggingAllowed === loggingAllowed.true ? this.activeButton : this.button} onClick={this.buttonAllowLogging}>
                            <span>
                              {/* <FormattedMessage {...translations.forms} /> */}
                              Yes
                            </span>
                          </a>
                        </p>
                        <p className="control">
                          <a className={this.props.profile.loggingAllowed === loggingAllowed.false ? this.activeButton : this.button} onClick={this.buttonDisallowLogging}>
                            <span>
                              {/* <FormattedMessage {...translations.code} /> */}
                              No
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>


          {/* Backup Stuff */}
          <div className="tile is-ancestor">
            <div className="tile is-vertical is-12">
              <div className="tile">
                <div className="tile is-parent is-vertical is-4">
                  <article className="tile is-child notification is-info">
                    <h1 className="title">
                      <FormattedMessage {...translations.backupTitle} />
                    </h1>
                    <p>
                      <FormattedMessage {...translations.backupDescription} />
                    </p>
                  </article>
                </div>
                <div className="tile is-parent">
                  <article className="tile is-child notification is-light">
                    <div className="field">
                      <label className="label">
                        <FormattedMessage {...translations.backupText} />
                      </label>
                      <div className="field has-addons">
                        <p className="control">
                          <a className={this.button} onClick={this.backupAllGenerators}>
                            <span className="icon is-small">
                              <i className="far fa-file-archive" />
                            </span>
                            <span>
                              <FormattedMessage {...translations.backupButton} />
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>

          {/* Backup Stuff */}
          <div className="tile is-ancestor">
            <div className="tile is-vertical is-12">
              <div className="tile">
                <div className="tile is-parent is-vertical is-4">
                  <article className="tile is-child notification is-warning">
                    <h1 className="title">
                      Restore to defaults
                    </h1>
                    <p>
                      Something is whack? Just reset all custom settings.
                    </p>
                  </article>
                </div>
                <div className="tile is-parent">
                  <article className="tile is-child notification is-light">
                    <div className="field">
                      <label className="label">
                        <input type="checkbox" name="restoreDefaults" checked={this.state.checkedRestore} onChange={this.activateRestoreButton} /> Check here to enable restore
                      </label>
                      <div className="field has-addons">
                        <p className="control">

                          <button className={this.button} onClick={this.restoreDefaults} disabled={!this.state.checkedRestore} >
                            <span className="icon is-small">
                              <i className="far fa-file-archive" />
                            </span>
                            <span>
                              Restore to defaults
                            </span>
                          </button>
                        </p>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>


        </div>

        <div className="box">
          {this.state.showCredits ? (
            <a className="button" onClick={this.toggleCredits}>
              <span className="icon">
                <i className="far fa-angle-double-up" />
              </span>
              <span>Credits</span>
            </a>
          ) : (
            <a className="button" onClick={this.toggleCredits}>
              <span className="icon">
                <i className="far fa-angle-double-down" />
              </span>
              <span>Credits</span>
            </a>
          )}
          <br />
          {this.state.showCredits ? (this.renderedCredits()) : ""}

        </div>
      </>
    );
  }

  private buttonCardView = () => {
    this.props.switchGenView(generatorView.cardView);
  };
  private buttonListView = () => {
    this.props.switchGenView(generatorView.listView);
  };
  private buttonFormsEditor = () => {
    this.props.switchEditView(preferredEditor.formEditor);
  };
  private buttonToggleTooltip = () => {
    if (this.props.profile.showTooltips === tooltips.on) {
      this.props.switchTooltipsSettings(tooltips.off)
    } else {
      this.props.switchTooltipsSettings(tooltips.on)
    }
  };
  private buttonCodeEditor = () => {
    this.props.switchEditView(preferredEditor.codeEditor);
  };
  private buttonThemeDark = () => {
    this.props.switchEditTheme(editorTheme.vsDark);
  };
  private buttonThemeLight = () => {
    this.props.switchEditTheme(editorTheme.vsLight);
  };
  private buttonLanguageEn = () => {
    this.props.switchAppLanguage(appLanguage.english);
  };
  private buttonLanguageFi = () => {
    this.props.switchAppLanguage(appLanguage.finnish);
  };
  private buttonLanguageDe = () => {
    this.props.switchAppLanguage(appLanguage.german);
  };

  private buttonAllowLogging = () => {
    this.props.switchLogging(loggingAllowed.true)
  };

  private buttonDisallowLogging = () => {
    this.props.switchLogging(loggingAllowed.false);
  };

  private btnToggleDelete = (bool: deleteConfirmation) => {
    this.props.toggleDelConf(bool);
  }

  private activateRestoreButton = () => {
    this.setState({
      ...this.state,
      checkedRestore: !this.state.checkedRestore
    })
  }

  private restoreDefaults = () => {
    resetProfile().then(() => {
      this.props.reloadProfile();
    })

  }

  // Backup Stuff
  private backupAllGenerators = () => {
    toast({ message: this.props.intl.formatMessage(translations.backupToastStarted), type: "is-info", dismissible: "true", position: "top-right", opacity: "1", duration: "3500" })
    const downloaded: GeneratorEntity[] = [];
    const zip = new JSZip();
    // zip.file("test.json", JSON.stringify(this.props.generators[0]));
    this.props.generators.forEach((gen: GeneratorEntity) => {
      loadGenDetails(gen.id || '')
        .then((result: GeneratorEntity) => {
          zip.file(result.name + '_' + result.id + ".json", JSON.stringify(result, null, '\t'));
          downloaded.push(result);
          if (downloaded.length === this.props.generators.length) {
            zip.generateAsync({ type: 'blob' })
              .then((content: any) => {
                saveAs(content, "GeneratorBackup.zip")
                toast({ message: this.props.intl.formatMessage(translations.backupToastCreated), type: "is-success", dismissible: "true", position: "top-right", opacity: "1", duration: "3500" })
              })
          }
        })
    });

  }
}

export default injectIntl(ProfileComponent)



// WEBPACK FOOTER //
// ./src/Containers/Profile/ProfileComponent.tsx